import React from 'react';
import AntdIcon from '@ant-design/icons/lib';
import styled from 'styled-components';

import paper from '../icons/paper.svg';
import changes from '../icons/changes.svg';
import data from '../icons/data.svg';
import logo from '../logo.svg';

// special require so we can index into icons based on icon name
const icons = require(`@ant-design/icons`);

export type IconType = 'antd' | 'url';

interface ImgIconProps {
    name: string;
    type?: IconType;
    alt: string;
    ariaHidden?: boolean;
}
export const ImgIcon = (props: ImgIconProps) => {
    const { name: value, alt = '', type = 'antd', ariaHidden, ...other } = props;

    if (type === 'antd') {
        const Component = icons[value];
        return <Component alt={alt} aria-hidden={ariaHidden ? 'true' : 'false'} {...other} />;
    }

    if (type === 'url') {
        let src = logo;
        switch (value) {
            case 'paper':
                src = paper;
                break;
            case 'changes':
                src = changes;
                break;
            case 'data':
                src = data;
                break;
        }
        return (
            <AntdIcon
                {...other}
                component={() => (
                    <img src={src} alt={alt} aria-hidden={ariaHidden ? 'true' : 'false'} />
                )}
            />
        );
    }

    throw new Error(`'${type}' is not a valid icon type.  Use 'antd' or 'url`);
};

export const H2ImgIcon = styled(ImgIcon)`
    img {
        vertical-align: baseline;
        height: ${({ theme }) => theme.typography.h2.fontSize};
    }
`;
